import React from "react";
import { useTheme } from "styled-components";

import { InputReactSelect, InputWrapper } from "./styles";
import { ErrorText } from "../InputText/styles";

export const InputSelectDefault = React.forwardRef(
  (
    {
      width,
      height,
      fontWeight,
      disabled,
      isSearchable = false,
      placeholder = "Selecione...",
      options,
      noOptionsMessage = "Sem Opções",
      defaultValue,
      isMulti,
      onChange,
      value,
      onInputChange,
      fontSize,
      isLoading = false,
      borderColor,
      isClearable,
      error,
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <InputWrapper width={width} height={height}>
        <InputReactSelect
          isSearchable={isSearchable}
          isClearable={isClearable}
          isMulti={isMulti}
          value={value}
          onChange={onChange}
          noOptionsMessage={() => noOptionsMessage}
          options={options}
          onInputChange={onInputChange}
          placeholder={placeholder}
          isLoading={isLoading}
          styles={{
            container: (base) => ({
              ...base,
              width: width || "auto",
              height: height || "40px",
              border: `1px solid ${error ? theme.colors.red500 : (borderColor || "#CACACA")}`,
            }),
            control: (base, state) => ({
              ...base,
              boxSizing: "border-box",
              height: height || "40px",
              border: `none`,
              boxShadow: "none",
              minHeight: "35px",
              paddingBottom: "5px",
              background: state.isDisabled
                ? theme.colors.gray000
                : "transparent",
              fontSize: fontSize || "14px",
              fontWeight: fontWeight || "regular",
              alignItems: "center",
              cursor: state.isDisabled ? "not-allowed" : "default",
            }),
            valueContainer: (provided, state) => ({
              ...provided,
              boxSizing: "border-box",
              height: height || "40px",
              paddingTop: 0,
              paddingLeft: "5px",
              alignItems: "center",
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
            input: (provided, state) => ({
              ...provided,
              boxSizing: "border-box",
              margin: 0,
              padding: 0,
            }),
            dropdownIndicator: (baseStyles, state) => ({
              ...baseStyles,
              color: "##515151",
              width: "30px",
              "&:hover": {
                color: "##515151",
              },
            }),
            indicatorsContainer: (provided, state) => ({
              ...provided,
              left: "-5px",
            }),
            option: (provided, state) => ({
              ...provided,
              fontSize: fontSize || "14px",
              backgroundColor: state.isSelected
                ? theme.colors.branding1000
                : "inherit",
              "&:hover": {
                backgroundColor: state.isSelected
                  ? theme.colors.branding900
                  : "rgb(222, 235, 255)",
              },
            }),
          }}
          isDisabled={disabled || isLoading}
        />
        {error && <ErrorText>{error}</ErrorText>}
      </InputWrapper>
    );
  }
);

InputSelectDefault.displayName = "InputSelectDefault";
